export default "__VITE_ASSET__CKm5fQGy__"